import React from "react";
import * as Sentry from "@sentry/react";
import { SENTRY_DSN } from "@/constants/env";

Sentry.init({
  dsn: SENTRY_DSN,
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

function FallbackComponent() {
  return <div>An error has occured</div>;
}

const SentryWrapper = ({ children }) => {
  return (
    <Sentry.ErrorBoundary fallback={FallbackComponent} showDialog>
      {children}
    </Sentry.ErrorBoundary>
  );
};

export default SentryWrapper;
